import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/work',
      name: 'work',
      component: () => import('./views/Work.vue'),
    },
    {
      path: '/statement',
      name: 'statement',
      component: () => import('./views/Statement.vue'),
    },
    {
      path: '/ndtimer',
      name: 'ndtimer',
      component: () => import('./views/NDtimer.vue'),
    },
    {
      path: '/ndtimer-privacy',
      name: 'ndtimerprivacy',
      component: () => import('./views/Privacy.vue'),
    },
    {
      path: '/forecast',
      name: 'forecast',
      component: () => import('./views/Forecast.vue'),
    },
  ],
});
